import { APP_BASE_HREF } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RECAPTCHA_LOADER_OPTIONS, RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { DBConfig, NgxIndexedDBModule } from 'ngx-indexed-db';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessagesModule } from 'primeng/messages';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { citaSessionInterceptor } from './app/core/interceptors/cita-session.interceptor';
import { generalInterceptor } from './app/core/interceptors/general.interceptor';
import { loadingInterceptor } from './app/core/interceptors/loading.interceptor';
import { environment } from './environments/environment';

const I18N_CONFIG: object = {
  defaultLanguage: environment.defaultLang,
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient],
  },
};
const dbConfig: DBConfig = {
  name: environment.storageKey,
  version: 1,
  objectStoresMeta: [
    {
      store: environment.storageKey,
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'type', keypath: 'type', options: { unique: false } },
        { name: 'name', keypath: 'name', options: { unique: false } },
        { name: 'size', keypath: 'size', options: { unique: false } },
        { name: 'file', keypath: 'file', options: { unique: false } },
        { name: 'amount', keypath: 'amount', options: { unique: false } },
      ],
    },
  ],
};
function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      AppRoutingModule,
      BrowserModule,
      NgxIndexedDBModule.forRoot(dbConfig),
      MessagesModule,
      RecaptchaV3Module,
      TranslateModule.forRoot(I18N_CONFIG)
    ),
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
      /* useFactory: (_environmentService: EnvironmentService) => {
              return _environmentService.environment;
            },
            deps: [EnvironmentService], */
    },
    {
      provide: RECAPTCHA_LOADER_OPTIONS,
      useValue: {
        onBeforeLoad(): any {
          return {
            url: new URL('https://www.google.com/recaptcha/enterprise.js'),
          };
        },
      },
    },
    { provide: APP_BASE_HREF, useValue: environment.baseHref },

    provideAnimations(),
    provideHttpClient(withInterceptors([loadingInterceptor, generalInterceptor, citaSessionInterceptor])),
  ],
}) // eslint-disable-next-line no-console
  .catch(err => console.error(err));
